<div class="row mt-4" *ngIf="orderData">
  <div class="col">
    <lib-gung-tabset #ngbTab="gungTabset" orientation="vertical" [collapsible]="true" [sidebarLabel]="'RELATED_MESSAGES' | translate">
      <div libGungTabsetHeader class="header-title d-flex flex-wrap align-items-center justify-content-between">
        <h3 class="mb-0 mr-3 text-break"><span translate="ORDER_MESSAGE"></span>: {{ orderData.id }}</h3>
        <div class="d-flex align-items-center">
          <lib-edi-send-status class="edi-status-badge mr-3" [message]="orderData"></lib-edi-send-status>
          <lib-edi-navigation-buttons class="mr-2" [baseRoute]="ediNavigationBaseRoute"></lib-edi-navigation-buttons>
          <lib-action-btn [(item)]="orderData" [config]="orderActionConfigService"> </lib-action-btn>
        </div>
      </div>
      <lib-gung-tab icon="fa-solid fa-file-import" [title]="'EDI_ORDER_DETAILS' | translate">
        <ng-template libGungTabContent>
          <div class="row pt-4">
            <div class="col-lg-7">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" translate>BUYER_ORDER_NUMBER</label>
                    <input class="form-control" type="text" [ngModel]="orderData?.documentReferences?.buyerOrder?.id" [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" translate>ORDER_DATE</label>
                    <input class="form-control" type="text" [ngModel]="orderData?.documentReferences?.buyerOrder?.date" [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" translate>ORDER_TYPE</label>
                    <input class="form-control" type="text" [ngModel]="orderData?.orderType" [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" translate>DELIVERY_DATE</label>
                    <input class="form-control" type="text" [ngModel]="orderData?.deliveryDate" [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4" *ngIf="!!orderData.timestamp">
                  <div class="form-group">
                    <label class="control-label" translate>TIMESTAMP</label>
                    <input class="form-control" type="text" [ngModel]="orderData?.timestamp" [disabled]="true" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="control-label" translate>GUNG_EDI_MESSAGE_SEND_STATUS</label>
                    <input class="form-control" type="text" [ngModel]="orderData?.gungEdiMessageSendStatus" [disabled]="true" />
                  </div>
                </div>
              </div>

              <div class="row px-2" *ngIf="orderData.erpIds">
                <div class="col-12 info-head">
                  <div class="row">
                    <div class="col">
                      <strong>THIS RESULTED IN ORDER IDS :</strong>
                      <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="table-responsive gung-responsive"
                *ngIf="
                  orderData.gungEdiMessageSendStatus == 'ErrorWhileSending' ||
                  orderData.gungEdiMessageSendStatus == 'ErrorReported'
                "
              >
                <div class="row">
                  <div class="col-9">
                    <h3>Errors occured when trying to create order</h3>
                  </div>
                </div>

                <div class="alert alert-warning">Contact: support&#64;gung.se</div>
                <table class="table table-striped">
                  <tbody>
                    <tr *ngFor="let error of orderData.stackTraceMap | keyvalue">
                      <td>
                        <pre>{{ error.value }}</pre>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="table-responsive gung-responsive"
                *ngIf="orderData.validationState == 'VALIDATED_WITH_ERRORS'"
              >
                <div class="row">
                  <div class="col-9">
                    <h3>
                      {{ orderData.validationState | translate }}
                    </h3>
                  </div>
                </div>

                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th class="col-2">Type</th>
                      <th class="col-4">Message</th>
                      <th class="col-1">Source</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let error of orderData.errors">
                      <td>
                        {{ error.type }}
                      </td>
                      <td>
                        {{ error.error }}
                      </td>
                      <td>
                        {{ error.validator }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-lg-5">
              <lib-edi-gln-number-tabs [ediMessage]="orderData"></lib-edi-gln-number-tabs>
            </div>
          </div>

          <div class="row">
            <h3 translate="ORDER_LINES"></h3>
            <lib-edi-row-table [data]="orderData.items" [columns]="itemsColumns" [rowClass]="itemRowClass"></lib-edi-row-table>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab icon="fa-solid fa-reply" [title]="'ORDER_RESPONSES' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <div class="row pt-4" *ngIf="relations">
            <div class="col-12">
              <div class="info-head"><strong>THIS RESULTED IN ORDER IDS :</strong>
                <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
              </div>
            </div>
            <div class="col-12 mt-3" *ngIf="ordrspToGenerate.length > 0">
              <h5 class="text-center" translate>ORDERS_IDS_READY_TO_GENERATE</h5>
              <div class="row">
                <div class="col-12">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th translate>ORDER_ID</th>
                        <th class="text-right" translate>TOOLS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let orderId of ordrspToGenerate">
                        <td>
                          {{ orderId }}
                        </td>
                        <td class="text-right">
                          <button
                            (click)="sendOrderResponseByOrderId(orderId)"
                            class="btn btn-sm btn-primary"
                            translate
                          >
                            GENERATE_MESSAGE
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-12 mt-3">
              <h5 class="text-center" translate>ORDER_RESPONSES</h5>
              <div class="row" *ngFor="let orderId of relations.erpOrderIds">
                <div class="col-12 card-body" *ngFor="let item of ordrspMap[orderId]; index as i">
                  <div class="row">
                    <div class="col-12 card-title">
                      <h5 class="d-inline">
                        <a [routerLink]="['/admin/edi/order-responses/', item.id]">
                          {{ item.id }}
                          <i class="fas fa-external-link-alt"></i>
                        </a>
                      </h5>
                      <div class="float-right">
                        <lib-action-btn
                          [(item)]="ordrspMap[orderId][i]"
                          [config]="orderResponseActionConfigService"
                        ></lib-action-btn>
                      </div>
                    </div>
                    <div class="col-12 col-md-4">
                      <lib-gung-text-input
                        renderStatic="true"
                        gungTranslate="STATUS"
                        [(ngModel)]="item.gungEdiMessageSendStatus"
                        class="label-bold"
                      >
                      </lib-gung-text-input>
                    </div>
                    <div class="col-12 col-md-4">
                      <lib-gung-text-input
                        renderStatic="true"
                        gungTranslate="VALIDATION_STATE"
                        [(ngModel)]="item.validationState"
                        class="label-bold"
                      >
                      </lib-gung-text-input>
                    </div>
                    <div class="col-12 col-md-4">
                      <lib-gung-text-input
                        renderStatic="true"
                        gungTranslate="MESSAGE_DATE"
                        [(ngModel)]="item.documentReferences.despatchAdvice.date"
                        class="label-bold"
                      ></lib-gung-text-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab icon="fa-solid fa-truck" [title]="'RELATED_EDI_DESADV' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <div class="row pt-4" *ngIf="relations">
            <div class="col-12">
              <div class="info-head"><strong>THIS RESULTED IN ORDER IDS :</strong>
                <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
              </div>
            </div>
            <div class="col-12">
              <p *ngIf="relations.erpDesadvIds.length == 0" translate>NO_DESPATCHES_FOUND</p>
              <div class="mt-3" *ngIf="despachtsToGenerate.length > 0">
                <h5 class="text-center" translate>DESPATCHES_IDS_READY_TO_GENERATE</h5>
                <div class="row">
                  <div class="col-12">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th translate>DESPATCH_ID</th>
                          <th class="text-right" translate>TOOLS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let desadvId of despachtsToGenerate">
                          <td>
                            {{ desadvId }}
                          </td>
                          <td class="text-right">
                            <button (click)="sendDesadvByDesadvId(desadvId)" class="btn btn-sm btn-primary" translate>
                              GENERATE_MESSAGE
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <h5 class="text-center" translate>DESPATCHES</h5>
                <div class="row" *ngFor="let desadvId of relations.erpDesadvIds">
                  <div class="col-12 card-body" *ngFor="let item of desadvMap[desadvId]; index as i">
                    <div class="row">
                      <div class="col-12 card-title">
                        <h5 class="d-inline">
                          <a [routerLink]="['/admin/edi/dispatch-advices/', item.id]">
                            {{ item.id }}
                            <i class="fas fa-external-link-alt"></i>
                          </a>
                        </h5>
                        <div class="float-right">
                          <lib-action-btn
                            [(item)]="desadvMap[desadvId][i]"
                            [config]="dispatchActionConfigService"
                          ></lib-action-btn>
                        </div>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="STATUS"
                          [(ngModel)]="item.gungEdiMessageSendStatus"
                          class="label-bold"
                        >
                        </lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="VALIDATION_STATE"
                          [(ngModel)]="item.validationState"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="MESSAGE_DATE"
                          [(ngModel)]="item.documentReferences.despatchAdvice.date"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab icon="fa-solid fa-file-invoice" [title]="'RELATED_EDI_INVOIC' | translate" *ngIf="orderData.erpIds">
        <ng-template libGungTabContent>
          <div class="row pt-4" *ngIf="relations">
            <div class="col-12">
              <div class="info-head"><strong>THIS RESULTED IN ORDER IDS :</strong>
                <a *ngFor="let erpId of orderData.erpIds" [routerLink]="['/orders', erpId]" class="ml-1">{{erpId}}</a>
              </div>
            </div>
            <div class="col-12">
              <p *ngIf="relations.erpInvoiceIds.length == 0" translate>NO_INVOICES_FOUND</p>
              <div class="row" *ngIf="relations.erpInvoiceIds.length > 0">
                <div class="col-12 mt-3" *ngIf="invoicesToGenerate.length > 0">
                  <h5 class="text-center" translate>INVOICES_IDS_READY_TO_GENERATE</h5>
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th translate>INVOICE_ID</th>
                            <th class="text-right" translate>TOOLS</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let invoiceId of invoicesToGenerate">
                            <td>
                              {{ invoiceId }}
                            </td>
                            <td class="text-right">
                              <button
                                (click)="sendInvoiceByInvoiceId(invoiceId)"
                                class="btn btn-sm btn-primary"
                                translate
                              >
                                GENERATE_MESSAGE
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-4">
                <h5 class="text-center" translate>INVOICES</h5>
                <div class="row" *ngFor="let invoiceId of relations.erpInvoiceIds">
                  <div class="col-12 card-body" *ngFor="let item of invoiceMap[invoiceId]; index as i">
                    <div class="row">
                      <div class="col-12 card-title">
                        <h5 class="d-inline">
                          <a [routerLink]="['/admin/edi/invoices/', item.id]">
                            {{ item.id }}
                            <i class="fas fa-external-link-alt"></i>
                          </a>
                        </h5>
                        <div class="float-right">
                          <lib-action-btn
                            [(item)]="invoiceMap[invoiceId][i]"
                            [config]="invoicesActionConfigService"
                          ></lib-action-btn>
                        </div>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="STATUS"
                          [(ngModel)]="item.gungEdiMessageSendStatus"
                          class="label-bold"
                        >
                        </lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="VALIDATION_STATE"
                          [(ngModel)]="item.validationState"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                      <div class="col-12 col-md-4">
                        <lib-gung-text-input
                          renderStatic="true"
                          gungTranslate="MESSAGE_DATE"
                          [(ngModel)]="item.documentReferences.invoice.date"
                          class="label-bold"
                        ></lib-gung-text-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab
        icon="fa-solid fa-file-lines"
        title="Source document"
        *ngIf="orderData.fileNameInclPath && (documentViewerEnabled$ | async)"
      >
        <ng-template libGungTabContent>
          <div class="pt-4">
            <lib-edi-document-viewer
              [messageId]="orderData.id"
              messageType="ORDER"
              [useAi]="true"
            ></lib-edi-document-viewer>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
</div>
